import $ from 'jquery';
import {reportUnexpectedAjaxError} from "./utils";
import {createCart} from "./shopify_client";

$(document).ready(function () {

    // this code applies to the chiropractor order form
    if ($('.template-chiropractor-order-form').length === 0) {
        return;
    }

    // Key is variantID, value is quantity. Only items with a qty > 0 are ever in the cart.
    const cartState = {};
    const $cart = $('.shopping-cart');
    const $overlay = $('.cart-overlay');
    const $checkoutBtn = $('.btn-checkout');

    // Catch all function which ensures the product card is up to date
    function updateProduct($product) {
        const productHandle = $product.data('product-handle');

        const selectedShoeType = $product.find(`[name="${productHandle}:shoe_type"]:checked`).val();

        // Hide all size options, then show the options for the selected shoe type
        $product.find('.size_container').hide();
        const $sizeContainer = $product.find(`.size_container[data-shoe-type="${selectedShoeType}"]`);
        $sizeContainer.show();

        const $sizeOptions = $sizeContainer.find('input.shoe_size:not([disabled])');
        // If a size option is not selected, select the first one
        if ($sizeOptions.filter(':checked').length === 0) {
            $sizeOptions.first().prop('checked', true);
        }

        const $selectedVariant = $sizeOptions.filter(':checked');
        let priceStr = '';
        if ($selectedVariant.length && $selectedVariant.data('variant-price')) {
            priceStr = formatPrice(getVariantPrice($selectedVariant.data('variant-id')));

            // Mark the selection so its easy to find later
            $product.find('.selected-variant').removeClass('selected-variant');
            $selectedVariant.addClass('selected-variant');
        }

        $product.find('.price').text(priceStr);
    }

    // Variant helpers
    const variantsCache = {};
    function getVariant(variantID) {
        let $variant = variantsCache[variantID];
        if (!$variant) {
            $variant = $(`.product_variant[data-variant-id="${variantID}"]`);
            variantsCache[variantID] = $variant;
        }

        return $variant;
    }

    function getProductForVariant(variantID) {
        return getVariant(variantID).closest('.product-card');
    }

    function getVariantPrice(variantID) {
        return parseFloat(getVariant(variantID).data('variant-price')) || 0;
    }

    function getLineTotal(variantID, qty) {
        return getVariantPrice(variantID) * qty;
    }

    function formatPrice(amount) {
        return '$' + amount.toFixed(2);
    }

    function formatQty(qty, singular, plural) {
        return qty + ' ' + (qty === 1 ? singular : plural);
    }

    function onCartChanged() {
        updateCartUI();

        // TODO: Persistence?
    }

    // Cart operations
    function addToCart(variantID, qty) {
        if (cartState[variantID]) {
            cartState[variantID] += qty;
        } else {
            cartState[variantID] = qty;
        }
        onCartChanged();
    }

    function updateCartItemQuantity(variantID, qty) {
        if (qty <= 0) {
            delete cartState[variantID];
        } else {
            cartState[variantID] = qty;
        }
        onCartChanged();
    }

    function updateCartUI() {
        let totalQty = 0;
        let subtotal = 0;
        for (const [variantID, qty] of Object.entries(cartState)) {
            totalQty += qty;
            subtotal += getLineTotal(variantID, qty);
        }

        $('.cart-item-count').text(totalQty);
        $('.cart-item-summary').text(formatQty(totalQty, 'Item', 'Items'));
        $('.subtotal-amt').text(formatPrice(subtotal));
        $checkoutBtn.toggleClass('disabled', totalQty === 0);

        // Remove all rendered items, and then recreate them
        $cart.find('.card-product').each(function () {
            const $item = $(this);
            const variantID = $item.data('variant-id');

            if (cartState[variantID]) {
                $item.remove(); // will be rebuilt - remove immediately
            } else {
                // The item will not be replaced, it no longer exists in the cart - fade it out
                $item.fadeOut(300, function () {
                    $(this).remove();
                });
            }
        });

        for (const [variantID, qty] of Object.entries(cartState)) {
            renderCartItem(variantID, qty);
        }
    }

    function renderCartItem(variantID, qty) {
        const $variant = getVariant(variantID);
        const $product = getProductForVariant(variantID);
        const $img = $product.find('.product-img').first();

        const $template = $('#cart-item-template');
        const $item = $($template.html());

        $item.attr('data-variant-id', variantID);
        $item.find('.product-image').attr(
            'src', $img.attr('src')
        ).attr(
            'alt', $img.attr('alt')
        );
        $item.find('.product-title').text($product.data('product-title'));
        $item.find('.price').text(formatPrice(getLineTotal(variantID, qty)));
        $item.find('.shoe_type').text($variant.data('shoe-type'));
        $item.find('.shoe_size').text($variant.data('shoe-size'));
        $item.find('.qty-value').data(
            'count', qty
        ).text(
            formatQty(qty, 'PAIR', 'PAIRS')
        );

        $cart.find('.container-product').append($item);
    }

    function openCart() {
        $cart.addClass('active');
        $overlay.addClass('active');
        $('body').addClass('no-scroll');
    }

    function closeCart() {
        $cart.removeClass('active');
        $overlay.removeClass('active');
        $('body').removeClass('no-scroll');
    }

    $(document).on('click', '.btn-basket', function (e) {
        e.preventDefault();
        openCart();
    });


    $(document).on('click', '.shopping-cart .close', function (e) {
        e.preventDefault();
        closeCart();
    });


    $overlay.on('click', closeCart);


    $(document).on('keydown', function (e) {
        if (e.key === 'Escape') {
            closeCart();
        }
    });

    $('.section-product').on('click', '.block-add-to-cart .close', function (e) {
        e.preventDefault();

        const $card = $(this).closest('.product-card');

        $card.find('.block-add-to-cart').removeClass('active');
        $card.find('.shop-now').removeClass('hidden');
    });

    $('.quantity').on('click', '.plus, .minus', function () {
        const $block = $(this).closest('.quantity');
        const $value = $block.find('.qty-value');

        let count = parseInt($value.data('count'));

        if ($(this).hasClass('plus')) {
            count++;
        } else {
            if (count > 1) count--;
        }

        $value
            .data('count', count)
            .text(formatQty(count, 'PAIR', 'PAIRS'));
    });

    $('.section-product').on('click', '.shop-now', function (e) {
        e.preventDefault();

        const $card = $(this).closest('.product-card');
        const $block = $card.find('.block-add-to-cart');

        $('.block-add-to-cart').removeClass('active');
        $('.shop-now').removeClass('hidden');

        $block.addClass('active');
        $(this).addClass('hidden');
    });

    // Setup all products on page init
    $('.product-card').each(function (_, el) {
        updateProduct($(el));
    }).on('change', 'input', function (e) {
        updateProduct($(e.currentTarget).closest('.product-card[data-product-handle]'))
    });

    // Fresh render on page init
    updateCartUI();

    // Update cart quantities
    $cart.on('click', '.quantity .plus, .quantity .minus', function () {
        const $cartItem = $(this).closest('.card-product');
        const variantID = $cartItem.data('variant-id');
        const currentQty = cartState[variantID];

        let newQty = $(this).hasClass('plus') ? currentQty + 1 : currentQty - 1;
        newQty = Math.max(newQty, 0);
        updateCartItemQuantity(variantID, newQty);
    });

    // Add items to cart
    $('.add-to-cart').click(function (e) {
        const $product = $(e.currentTarget).closest('.product-card[data-product-handle]');
        const $selectedVariant = $product.find('.selected-variant');

        if (!$selectedVariant.length) {
            return;
        }

        const qty = parseInt($product.find('.qty-value').data('count'));
        addToCart($selectedVariant.data('variant-id'), qty);
        setTimeout(openCart, 500);
    });

    // Complete checkout by creating the shopify cart URL and redirecting
    let bAjaxRunning = false;
    $checkoutBtn.click(async function () {
        if (bAjaxRunning) {
            return;
        }

        bAjaxRunning = true;
        $(document.body).css('cursor', 'progress');

        const vars = {
            lines: [],
            discountCodes: 'CHIRO0126',
            attributes: [
                {
                    // Pass site code for attribution
                    key: 'protalus_works_site',
                    value: $('[name="site_code"]').val()
                }
            ]
        }

        for (const [variantID, qty] of Object.entries(cartState)) {
            vars.lines.push({
                quantity: qty,
                merchandiseId: variantID
            });
        }

        try {
            const resp = await createCart({cartInput: vars});
            const url = resp['data']['cartCreate']['cart']['checkoutUrl'];
            console.log(`Created cart URL: ${url}. Redirecting now.`);
            window.location.href = url;
        } catch (e) {
            console.error('Failed to fetch shopify cart URL', e);
            reportUnexpectedAjaxError(e, 'checking out');
            bAjaxRunning = false;
            $(document.body).css('cursor', '');
        }

    })
});
